var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConquistar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 92,
    viewBox: "0 0 93 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0048 31V28H63.2057V31H31.0048ZM31.2556 60V47.1H28.7979V44.1L31.0048 34H63.1555L65.3624 44.1V47.1H62.9047V60H59.8953V47.1H50.4156V60H31.2556ZM34.265 57H47.4062V47.1H34.265V57ZM31.7572 44.1H62.4031L60.8483 37H33.312L31.7572 44.1Z",
    fill: "#737791"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.911 22C59.3737 22 54.8796 26.48 54.8796 32C54.8796 37.52 59.3737 42 64.911 42C70.4484 42 74.9424 37.52 74.9424 32C74.9424 26.48 70.4484 22 64.911 22ZM69.9267 33H65.9142V37H63.9079V33H59.8953V31H63.9079V27H65.9142V31H69.9267V33Z",
    fill: "#737791"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.499 46C92.499 71.1275 72.0647 91.5 46.8545 91.5C21.6442 91.5 1.20996 71.1275 1.20996 46C1.20996 20.8725 21.6442 0.5 46.8545 0.5C72.0647 0.5 92.499 20.8725 92.499 46Z",
    stroke: "#737791"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConquistar);
export default __webpack_public_path__ + "static/media/conquistar.4b8c9317e6baf367b661547c383b3781.svg";
export { ForwardRef as ReactComponent };